import { AuthenticationStrategy } from '@shared/interfaces/authentication-strategies.interface';
import { AuthContext } from '@shared/interfaces/auth-context.interface';
import { NormalInitStrategyConfig } from '@shared/services/normal-init-strategy/normal-init-strategy.config';
import Keycloak, { KeycloakFlow, KeycloakLoginOptions, KeycloakOnLoad, KeycloakPkceMethod } from 'keycloak-js';
import { SessionStorageService } from '@nequi/design-system-lib/logic';
import { getKeycloakInstance } from '@shared/utils/keycloak/app.init';
import { saveTokens } from '@shared/utils/keycloak-token/keycloak-token';

export class NormalInitStrategy implements AuthenticationStrategy {
  public canHandle(): boolean {
    return true;
  }

  public async execute(context: AuthContext, options: KeycloakLoginOptions): Promise<boolean> {
    const isCancelRoute = context.pathname.includes(NormalInitStrategyConfig.publicRoute);
    return await this.tryInitNormally(context.sessionStorage, options, isCancelRoute);
  }

  private async tryInitNormally(
    sessionStorageService: SessionStorageService,
    options: KeycloakLoginOptions,
    isCancelRoute: boolean,
  ): Promise<boolean> {
    const keycloak: Keycloak = getKeycloakInstance();

    try {
      const authenticated = await keycloak.init({
        pkceMethod: NormalInitStrategyConfig.pkceMethod as KeycloakPkceMethod,
        flow: NormalInitStrategyConfig.flow as KeycloakFlow,
        checkLoginIframe: NormalInitStrategyConfig.checkLoginIframe,
        onLoad: NormalInitStrategyConfig.checkSso as KeycloakOnLoad,
      });

      if (!authenticated && !isCancelRoute) {
        await keycloak.login(options);
        return true;
      }

      saveTokens(sessionStorageService);
    } catch (err) {
      if (!isCancelRoute) throw err;
    }

    return true;
  }
}
